import appStore from 'store';
import api from './api';
import { BILL_TYPE } from './constants';

const store = {
  namespaced: true,
  state: {
    coinTypeList: [],
    billTypes: {},
    activeTab: 'all',
    pagination: {
      page: 1,
      size: 10
    },
    bills: [],
    totalCount: 0,
    lookobj:{}
  },
  getters: {
    billTypeList: state => {
      return Object.keys(state.billTypes)
        .map(item => {
          let re = {
            label: BILL_TYPE[state.billTypes[item]],
            value: item
          }
          if (item == 30) {
            re = {
              label: '转入',
              value: item
            }
          } else if (item == 31) {
            re = {
              label: '转出',
              value: item
            }
          }
          return re;

        });
    },
    billList: state => {
      return state.bills.map(item => ({
        ...item,
        __type: BILL_TYPE[item.businessType]
      }));
    }
  },
  mutations: {
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setBillTypeList(state, payload) {
      state.billTypes = payload;
    },
    setBillList(state, payload) {
      state.bills = payload.list.concat();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    changeTab(state, payload) {
      state.activeTab = payload;
    },
    // setlook(state, payload){
    //   state.lookobj = payload
    // }
    
  },
  actions: {
    listCoinType({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    listBillType({ commit }) {
      api.getBillTypeList().then(({ data }) => {
        commit('setBillTypeList', data);
      });
    },
    reqBills({ commit }, query) {
      api.reqBills(query).then(({ data }) => {
        data.list.map(item=>{
          item.lookwallet = '点击查看'
        })
        commit('setBillList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    reqBillsExcel({ commit }, query) {
      api.reqBills(query).then(({ data }) => {
        console.log(data.list)
        const fileName = "用户账单.xlsx";
        const blob = new Blob([data.list], {type: 'application/vnd.ms-excel'});
        if ('download' in document.createElement('a')) {
          const link = document.createElement('a');
          link.download = fileName;
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    // getLook({ commit }, query) {
    //   setTimeout(()=>{
    //     api.getLook(query).then(({ data }) => {
    //       // data.lookwalletType = 
    //       if(data != null){
    //         data.walletType=  data.walletType == 'WALLET'?
    //       '我的钱包':data.walletType == 'MARGIN'?
    //       '杠杆账户':data.walletType == 'OTC'?
    //       '法币账户':data.walletType == 'CONTRACT'?'合约账户':'超级合约账户账户'
    //       }
    //       commit('setlook', data);
    //     });
    //   },1000)
      
    // }
  }
};

appStore.registerModule('userBill', store);
